export const FETCH_ALL_ORDER = 'FETCH_ALL_ORDER';
export const FETCH_ALL_ORDER_FAILED = 'FETCH_ALL_ORDER_FAILED';
export const FETCH_ALL_ORDER_SUCCEED = 'FETCH_ALL_ORDER_SUCCEED';

export const FETCH_OPEN_ORDER = 'FETCH_OPEN_ORDER';
export const FETCH_OPEN_ORDER_FAILED = 'FETCH_OPEN_ORDER_FAILED';
export const FETCH_OPEN_ORDER_SUCCEED = 'FETCH_OPEN_ORDER_SUCCEED';

export const FETCH_ORDERS = 'FETCH_ORDERS';
export const FETCH_ORDERS_FAILED = 'FETCH_ORDERS_FAILED';
export const FETCH_ORDERS_SUCCEED = 'FETCH_ORDERS_SUCCEED';

export const FETCH_ORDER = 'FETCH_ORDER';
export const FETCH_ORDER_FAILED = 'FETCH_ORDER_FAILED';
export const FETCH_ORDER_SUCCEED = 'FETCH_ORDER_SUCCEED';

export const FETCH_ORDER_PAGINATE = 'FETCH_ORDER_PAGINATE';
export const FETCH_ORDER_PAGINATE_SUCCEED = 'FETCH_ORDER_PAGINATE_SUCCEED';
export const FETCH_ORDER_PAGINATE_FAILED = 'FETCH_ORDER_PAGINATE_FAILED';

export const CANCEL_ORDER = 'CANCEL_ORDER';
export const CANCEL_ORDER_SUCCEED = 'CANCEL_ORDER_SUCCEED';
export const CANCEL_ORDER_FAILED = 'CANCEL_ORDER_FAILED';

export const CANCEL_ALL_ORDER = 'CANCEL_ALL_ORDER';
export const CANCEL_ALL_ORDER_SUCCEED = 'CANCEL_ALL_ORDER_SUCCEED';
export const CANCEL_ALL_ORDER_FAILED = 'CANCEL_ALL_ORDER_FAILED';

export const ADD_ORDER = 'ADD_ORDER';
export const ADD_ORDER_SUCCEED = 'ADD_ORDER_SUCCEED';
export const ADD_ORDER_FAILED = 'ADD_ORDER_FAILED';

export const WS_EVENT_ORDER_CREATED = 'WS_EVENT_ORDER_CREATED';
export const WS_EVENT_ORDER_CANCELED = 'WS_EVENT_ORDER_CANCELED';
export const WS_EVENT_OPEN_ORDER = 'WS_EVENT_OPEN_ORDER';

export const FETCH_OPEN_ORDERS_PAGINATE = 'FETCH_OPEN_ORDERS_PAGINATE';
export const FETCH_OPEN_ORDERS_PAGINATE_SUCCEED = 'FETCH_OPEN_ORDERS_PAGINATE_SUCCEED';
export const FETCH_OPEN_ORDERS_PAGINATE_FAILED = 'FETCH_OPEN_ORDERS_PAGINATE_FAILED';
